<div id="modalGeneral" class="modal fade-modal in-modal">
  <div class="modal-dialog modal-sm max-w-360">
    <div class="modal-content">
      <div class="modal-body text-center p-16">
        <h5 class="f12 fw-bold uppercase pb-8 m-0" [innerHTML]="title"></h5>
        <p class="f13 m-0 mb-30" [innerHTML]="message"></p>
        <div
          *ngIf="!!btnCancel || !!btnSave"
          class="flex align-items-center"
          [ngClass]="{
            'justify-content-between': !!btnCancel && !!btnSave,
            'justify-content-center': !btnCancel || !btnSave
          }">
          <ps-button
            *ngIf="btnCancel"
            color="secondary"
            height="tall"
            [text]="btnCancel"
            (onClick)="close()">
          </ps-button>
          <ps-button
            *ngIf="btnSave"
            height="tall"
            [text]="btnSave"
            (onClick)="close(true)">
          </ps-button>
        </div>
      </div>
    </div>
  </div>
</div>
